export function valueToColor(val) {
    let rgbVal = Math.round(val * 255);
    return `#${[1, 2, 3].map(() => ("00" + rgbVal.toString(16)).slice(-2)).join('')}`;
}


import Color from "color";

/**
 * TODO: Cleanup
 *
 * @param color
 * @returns {string}
 */
export function metallicColor(color){
    // Note to self: this is different from what is currently in 2d-customizer. Different color conversion package
    let c = Color(color);
    let h = c.hsl();
    let lightnessFactor = Math.max(Math.min(2*h.color[2]/100, 1), .25);
    // let lightnessFactor = Math.pow((100-h.color[2])/100,.5);
    let mod = Color.hsl(
        h.color[0], // Hue untouched
        Math.min(lightnessFactor*h.color[1]*2,100), // Slightly extra saturated but scaled by the original lightness (so darker colors that didnt show much saturation don't get oversaturated now)
        Math.min(100-(h.color[1]*.3), 10+Math.max(2*h.color[2], 30)))// Lightness boosted dynamically, 50 for pure black, and potentially to 100% white for lighter colors
    let hex = mod.rgb().hex();
    console.log(`${color} (HSV: ${h.toString()})` + " > METAL: " + hex + ` (HSV: ${mod.toString()})`);
    return hex;
}

/**
 * Map an input value to an input value. Based on linear interpolation between 2 points.
 *
 * @param value
 * @param stops
 */
function mapValue(value, stops){
    let indexOf = stops.findIndex((stop,index)=>{
        let next = stops[index+1];
        if(!next) return true;
        let start = stop.start || 0.0;
        if(value>=stop.start && value<next.start) return true;
    });
    let stop = stops[indexOf];
    let stopEnd = stops[indexOf+1] || {start: 1.0, value: 1.0};
    let perc = (value-stop.start)/(stopEnd.start-stop.start);
    if( !Number.isFinite(perc)) perc = 0;
    let output = ((1.0-perc)*stop.value) + ((perc)*stopEnd.value);
    return output;
}


/**
 * Correct colors for use with metallic in the PBR. Color needs to be lightened and saturated a bit to show as expected
 *
 * @param color
 * @returns {string}
 */
export function colorCorrectMetallic(color) {
    return colorCorrectNonMetallic(color);// Metallic is no longer handled differently! (but it used to be)
}


/**
 * Correct colors for non-metallic parts. Color needs to be lightened a bit to show as expected
 *
 * @param color
 * @returns {string}
 */
export function colorCorrectNonMetallic(color) {
    // This is modified from colorCorrectMetallic with less saturation and lightness
    let c = Color(color);
    let h = c.hsl();
    
    // Normalize to 1.0;
    let s = h.color[1]/100;
    let l = h.color[2]/100;
    
    const addSat = mapValue(l, [
        {start: 0.0, value: -1.0},
        {start: 0.1, value: 0.0},
        {start: 0.5, value: 0.125},
    ])
    const lightMod = mapValue(s, [
        {start: 0.0, value: 0.0},
        {start: 0.5, value: 0.0},
        {start: 1.0, value: 0.035},
    ])
    
    let sOut = mapValue(s, [
        {start: 0.0,    value: 0.0},
        {start: 0.2,    value: 0.2},
        {start: 1-addSat,    value: 1.0},
    ]);
    let lOut = mapValue(l,[
        {start: 0.0,    value: 0.0},
        {start: 0.1,    value: 0.1+lightMod},
        {start: 0.2,    value: 0.25},
        {start: 0.95,    value: 1.0},
    ]);
    
    let mod = Color.hsl(
        h.color[ 0 ], // Hue untouched
        sOut * 100, // Saturation
        lOut * 100, // Lightness
    );
    let hex = mod.rgb().hex();
    console.log(`[NMET] ${color} (HSV: ${h.toString()})` + " > CORR: " + hex + ` (HSV: ${mod.toString()})`);
    return hex;
}
